<template>
	<h1>M01</h1>
</template>
<script>
export default {
	data() { return {
	}},
	state: {
	},
	mounted() {
	},
	methods: {
	},
	computed: {
	},
	mutations: {
	}
}
</script>
<style lang="less" Scoped>
</style>